// extracted by mini-css-extract-plugin
export var askAiIcon = "_n6-j";
export var category = "_n6-9";
export var categoryHeader = "_n6-e";
export var container = "_n6-0";
export var group = "_n6-a";
export var groupItems = "_n6-f";
export var groupSeparator = "_n6-k";
export var loading = "_n6-1";
export var noResults = "_n6-3";
export var placeholder = "_n6-2";
export var resultContent = "_n6-5";
export var resultIcon = "_n6-c";
export var resultItem = "_n6-g";
export var resultMeta = "_n6-8";
export var resultSubtitle = "_n6-7";
export var resultSuffix = "_n6-i";
export var resultTitle = "_n6-6";
export var resultsList = "_n6-4";
export var searchGroup = "_n6-d";
export var selected = "_n6-h";
export var subgroup = "_n6-b";